<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ partner.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <PartnersTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CRow v-for="pharmacy in pharmacyList" :key="pharmacy.title">
                        <CCol
                            tag="label"
                            sm="6"
                            class="col-form-label">
                            {{ pharmacy.title }}
                        </CCol>
                        <CCol sm="6">
                            <CSwitch
                                color="dark"
                                shape="pill"
                                variant="opposite"
                                :checked.sync="pharmacyEnabled[pharmacy.id]"
                            />
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import PartnersTabLinks from '@/components/partner/PartnersTabLinks';

    export default {

        name: 'PartnerPharmacy',
        components: {
            PartnersTabLinks,
        },

        data() {
            return {
                partner: {},
                pharmacyList: [],
                pharmacyEnabled: [],
            };
        },

        computed: {},

        mounted() {
            const id = parseInt(this.$route.params.id);
            Vue.axios
                .get('/partners/' + id)
                .then(resp => {
                    const partner = resp.data;
                    if (!partner.pharmacy) partner.pharmacy = [];
                    this.partner = partner;
                    Vue.axios
                        .get('/pharmacies/')
                        .then(resp => {
                            this.pharmacyList = resp.data;
                            this.initPharmacyEnabled();
                        })
                        .catch(err => {
                            this.$root.$emit('showError', 'Ошибка загрузки данных.');
                        });
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            save() {
                this.partner.pharmacyList = [];
                for (var i = 0; i < this.pharmacyList.length; i++) {
                    if (this.pharmacyEnabled[this.pharmacyList[i].id]) {
                        this.partner.pharmacy.push(this.pharmacyList[i].id);
                    }
                }
                Vue.axios
                    .put('/partners/' + this.partner.id + '/pharmacy', {
                        pharmacy: this.partner.pharmacy,
                    })
                    .then(resp => {
                        this.goBack();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },
            initPharmacyEnabled() {
                this.pharmacyEnabled = [];
                for (var i = 0; i < this.pharmacyList.length; i++) {
                    this.pharmacyEnabled[
                        this.pharmacyList[i].id
                    ] = this.partner.pharmacy.includes(this.pharmacyList[i].id);
                }
            },
            goBack() {
                this.$router.push({ path: '/partners/' + this.partner.id });
            },
        },
    };
</script>
